import React from 'react'
import Typography from '@material-ui/core/Typography';

const TermsOfService = () => (
  <Typography component="h1" variant="h4">Terms of Service</Typography>
)

export default TermsOfService;
